import { useCallback } from 'react'

import { F0ButtonToggle } from '@factorialco/f0-react'
import { VideoRecorder, VideoRecorderNegative } from '@factorialco/f0-react/icons/app'
import { usePersistentUserChoices } from '@livekit/components-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface PrejoinCameraButtonProps {
  onVideoEnabledChange: (enabled: boolean) => void
}
export const PrejoinCameraButton = ({ onVideoEnabledChange }: PrejoinCameraButtonProps) => {
  const { userChoices, saveVideoInputEnabled } = usePersistentUserChoices()

  const handleCameraToggle = useCallback(() => {
    saveVideoInputEnabled(!userChoices.videoEnabled)
    onVideoEnabledChange(!userChoices.videoEnabled)
  }, [userChoices.videoEnabled, saveVideoInputEnabled, onVideoEnabledChange])

  return (
    <F0ButtonToggle
      icon={userChoices.videoEnabled ? VideoRecorder : VideoRecorderNegative}
      label={i18n.t('meetings.prejoin.control_bar.camera.label')}
      onSelectedChange={() => {
        track(trackingEvents.meetings.ControlBarVideoButton, {
          isVideoEnabled: !userChoices.videoEnabled,
        })
        handleCameraToggle()
      }}
      size="lg"
      selected={userChoices.videoEnabled}
    />
  )
}
